/**
 * Design guide routes — /design (dev/stage only)
 *
 * Excluded from production builds via a Vite alias that swaps this module
 * for designGuideRoutes.prod.ts (empty array) — see vite.config.ts.
 * All routes are meta.unguarded so the guide works without a session.
 */

import { type RouteRecordRaw, RouterView } from 'vue-router';

const DesignGuideNavigation = () =>
  import('@/contexts/designGuide/DesignGuideNavigation.vue');
const DesignOverview = () => import('@/views/design/DesignOverview.vue');
const ColorPaletteOverview = () =>
  import('@/views/design/ColorPaletteOverview.vue');
const IconOverview = () => import('@/views/design/IconOverview.vue');
const IconSizesOverview = () => import('@/views/design/IconSizesOverview.vue');
const IconExport = () => import('@/views/design/IconExport.vue');
const FormOverview = () => import('@/views/design/FormOverview.vue');

// Prototypes
// ⚠️  MAINTENANCE NOTE: If removing designGuidePrototypeRoutes, update
//    scripts/screenshot-prototypes.ts to manually maintain prototype discovery.
const HelloWorld = () => import('@/views/prototypes/HelloWorld.vue');

export const designGuidePrototypeRoutes: RouteRecordRaw[] = [
  {
    component: HelloWorld,
    meta: { unguarded: true },
    name: 'design.prototype.hello-world',
    path: 'hello-world'
  }
];

export const designGuideRoutes: RouteRecordRaw[] = [
  {
    components: {
      default: RouterView,
      LeftSidebar: DesignGuideNavigation
    },
    meta: { unguarded: true },
    name: 'design',
    path: '/design',
    redirect: { name: 'design.overview' },
    children: [
      {
        component: DesignOverview,
        meta: { unguarded: true },
        name: 'design.overview',
        path: ''
      },
      {
        component: ColorPaletteOverview,
        meta: { unguarded: true },
        name: 'design.color-palette',
        path: 'color-palette'
      },
      {
        component: IconOverview,
        meta: { unguarded: true },
        name: 'design.icons',
        path: 'icons'
      },
      {
        component: IconSizesOverview,
        meta: { unguarded: true },
        name: 'design.icon-sizes',
        path: 'icon-sizes'
      },
      {
        component: IconExport,
        meta: { unguarded: true },
        name: 'design.icon-export',
        path: 'icon-export'
      },
      {
        component: FormOverview,
        meta: { unguarded: true },
        name: 'design.form',
        path: 'form'
      },
      // Prototypes automatically added below
      {
        component: RouterView,
        meta: { unguarded: true },
        name: 'design.prototypes',
        path: 'prototypes',
        children: designGuidePrototypeRoutes
      }
    ]
  }
];
